import { LabelContainer } from "../assets/style";

interface HookFormTextareaProps {
    title: any
    style?: any
    register: () => any
}

export default function HookFormTextarea(props: HookFormTextareaProps) {
    const { title, style, register } = props
    const textareaStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        height: "100px",
        width: "50%",
        ...style,
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
    };

    const lableContainerStyle = {
        marginLeft: "28px",
        marginTop: "10px",
        alignSelf: "start"
    }

    return (
        <div style={containerStyle}>
            <LabelContainer style={lableContainerStyle}>
                {title + ": "}
            </LabelContainer>
            <textarea
                style={textareaStyle}
                {...register()}
            />

        </div>
    )
}
